import firebase from "datastore/database";
import { update as updateBusinessCustomer } from "api/business-customers";
import { add as addVisit } from "api/visits";

export default async function logVisit({
  businessUid,
  customerUid,
  reason,
  served,
  uid,
  status,
  ...others
}) {
  const time = new Date();
  const data = {
    feedbackRequested: null,
    processedTime: time,
    ...(reason && { reason }),
    served,
    ...(status && { status }),
    ...others,
  };
  const { addresses, email, name, phoneNumber, ...customerVisitData } = data;
  const visit = {
    ...data,
    ...(customerUid && { customerUid }),
    ...(uid && { uid }),
  };

  if (customerUid) {
    updateBusinessCustomer(businessUid, customerUid, {
      lastVisit: time,
      visits: firebase.firestore.FieldValue.arrayUnion(customerVisitData),
      visitsCount: firebase.firestore.FieldValue.increment(1),
    });
  }

  return addVisit(businessUid, visit);
}
